const styles = {
    width: '100%',
    height: '100%',
    borderStyle: 'solid',
    borderRadius: '20px',
    textDecoration: 'none'
};

export default styles;
